import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeftIcon } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { CreateOrganizationForm } from '@/components/organization/CreateOrganizationForm';

export const Route = createFileRoute('/_authenticated/create-organization')({
  component: CreateOrganizationPage,
});

function CreateOrganizationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <Button variant="ghost" onClick={() => navigate({ to: '/dashboard' })} className="mb-4">
          <ArrowLeftIcon className="w-4 h-4 mr-2" />
          {t('organization.backToDashboard')}
        </Button>
        <h1 className="text-3xl font-bold">{t('organization.title')}</h1>
        <p className="text-muted-foreground mt-2">
          {t('organization.description')}
        </p>
      </div>

      <CreateOrganizationForm
        onSuccess={(org) => {
          navigate({ to: `/org/${org.id}` });
        }}
        showTitle={true}
        showDescription={true}
      />
    </div>
  );
}

